require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./firstcollegium-2021.json") })
        }
      }, "path---firstcollegium-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---firstcollegium-2021!./.cache/json/firstcollegium-2021.json
// module id = 1064
// module chunks = 231608221292675